import React from 'react';
import styled from 'styled-components';
import { HashRouter, Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { useScreenQuery } from 'playup-web-core';

import { WithdrawMethods } from './USWithdrawService';

import { getWithdrawalRequestTypes } from '../../../api/users';
import USWithdrawPaymentSelection from './USWithdrawPaymentSelection';
import USWithdrawPaymentCreation from './USWithdrawPaymentCreation';
import USWithdrawEnrollment from './USWithdrawEnrollment';
import USWithdrawSuccess from './USWithdrawSuccess';

const USWithdrawModal = () => {
	const { isSmall } = useScreenQuery();

	const [availableWithdrawMethodIds, setAvailableWithdrawMethodIds] = React.useState<Array<number>>([]);
	const [availableWithdrawMethodSummaries, setAvailableWithdrawMethodSummaries] = React.useState<
		Array<WithdrawalRequestType>
	>([]);
	const [withdrawAmount, setWithdrawAmount] = React.useState<number>(0);
	const [selectedWithdrawMethod, setSelectedWithdrawMethod] = React.useState<WithdrawalRequestType>();

	React.useEffect(() => {
		const loadWithdrawInformation = async () => {
			const withdrawalRequestTypes = await getWithdrawalRequestTypes();
			const availableWithdrawMethods = Object.values(withdrawalRequestTypes.data);
			setAvailableWithdrawMethodIds(availableWithdrawMethods.map((method) => method.withdrawal_request_type.id));
			setAvailableWithdrawMethodSummaries(availableWithdrawMethods);

			const minimumWithdrawAmount = withdrawalRequestTypes.meta.min_withdrawal;
			if (minimumWithdrawAmount && minimumWithdrawAmount > 0) {
				setWithdrawAmount(minimumWithdrawAmount);
			}
		};
		loadWithdrawInformation();
	}, []);

	const filteredWithdrawMethods = Object.values(WithdrawMethods).filter((paymentMethod) =>
		availableWithdrawMethodIds.includes(paymentMethod.id)
	);

	return (
		<>
			<Helmet title="Withdraw" />
			<PageContainer isSmallScreen={isSmall}>
				{isSmall && <Title>Withdraw</Title>}
				<HashRouter>
					<Switch>
						<Route exact path="/">
							<USWithdrawPaymentSelection
								availableWithdrawMethods={filteredWithdrawMethods}
								availableWithdrawMethodSummaries={availableWithdrawMethodSummaries}
								setSelectedWithdrawMethod={setSelectedWithdrawMethod}
							/>
						</Route>
						<Route exact path="/enrollment/:paymentMethodName">
							<USWithdrawEnrollment />
						</Route>
						<Route exact path="/request/:paymentMethodName">
							<USWithdrawPaymentCreation
								selectedWithdrawMethod={selectedWithdrawMethod}
								setWithdrawAmount={setWithdrawAmount}
							/>
						</Route>
						<Route exact path="/success/:paymentMethodName">
							<USWithdrawSuccess withdrawAmount={withdrawAmount} />
						</Route>
					</Switch>
				</HashRouter>
			</PageContainer>
		</>
	);
};

export default USWithdrawModal;

// This part is from web-core, change both to stay consistent ======
const PageContainer = styled.div<{ isSmallScreen: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: ${({ theme }) => theme.colors.white};

	${({ isSmallScreen }) => !isSmallScreen && 'max-width: 752px; margin: 30px auto 0;'}
`;
// This part is from web-core, change both to stay consistent ======

export const BodyContainer = styled.div<{ isSmallScreen: boolean }>`
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-top: ${({ isSmallScreen }) => (isSmallScreen ? '25px' : '40px')};
	margin-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '25px' : '40px')};
	padding-left: ${({ isSmallScreen }) => (isSmallScreen ? '15px' : '50px')};
	padding-right: ${({ isSmallScreen }) => (isSmallScreen ? '15px' : '50px')};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
	color: ${({ theme }) => theme.colors.darkR};
`;

export const NormalText = styled.p<{ isSmallScreen: boolean }>`
	margin: 0;
	fontsize: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
	color: ${({ theme }) => theme.colors.darkR};
`;

export const BoldText = styled.p<{ isSmallScreen: boolean }>`
	margin: 0;
	fontsize: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
	font-weight: 600;
	color: ${({ theme }) => theme.colors.darkR};
`;

const Title = styled.p`
	text-align: center;
	width: 100%;
	padding: 10px;
	background-color: ${({ theme }) => theme.colors.darkR};
	font-size: 16px;
	color: ${({ theme }) => theme.colors.white};
`;
